import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "homeFilled"
const HomeFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.28 11.47C21.724 12.026 20.84 12.053 20.25 11.552V21C20.25 21.828 19.578 22.5 18.75 22.5H15.75V15.75C15.75 14.922 15.078 14.25 14.25 14.25H9.75C8.922 14.25 8.25 14.922 8.25 15.75V22.5H5.25C4.422 22.5 3.75 21.828 3.75 21V11.552C3.16 12.053 2.276 12.026 1.72 11.47L12 1.19z" />
          <path d="M14.25 15.75V22.5H9.75V15.75z" />
        </svg>
      }
    </span>
  )
}
export default HomeFilledIcon
